import React from 'react';

import { RichText } from 'src/components/RichText/RichText';

import { getAdvancedSettings } from '../advancedSettings';
import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';

import type { TextType } from './textConfigAggregator';

type PageBuilderTextProps = TextType;

/**
 * Return the PB Text
 * @param props
 * @constructor
 */
export function PageBuilderText(props: PageBuilderTextProps) {
    /**
     * Configure the styles requires for the Block
     */
    const advancedSettings = getAdvancedSettings<PageBuilderTextProps>(props);

    const textClassNames = ['pageBuilderTextGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        textClassNames.push(...props.cssClasses);
    }

    /**
     * Render the Text Block UI
     */
    return (
        <PageBuilderElementWrapper
            contentType={props.contentType}
            uniqueID={props.uniqueID}
            styles={advancedSettings}
            classNames={textClassNames}
        >
            <RichText content={props.content ?? ''} />
        </PageBuilderElementWrapper>
    );
}
